import { getStatsigClient, waitForInitializingStatsigClient } from "./client";
export function logEvent(eventName, value, metadata) {
    const client = getStatsigClient();
    if (!client || typeof client.logEvent !== "function")
        return;
    try {
        client.logEvent(eventName, value, metadata);
    }
    catch (_error) { }
}
export async function logEventAndFlush(eventName, value, metadata, timeoutMs) {
    const client = getStatsigClient() || await waitForInitializingStatsigClient(timeoutMs);
    if (!client || typeof client.logEvent !== "function")
        return;
    try {
        client.logEvent(eventName, value, metadata);
        if (typeof client.flush === "function") {
            await client.flush();
        }
    }
    catch (_error) { }
}
